import * as api from './api';
import * as checklists from './checklists';
import * as colors from './colors';
import * as credentials from './credentials';
import * as fields from './fields';
import * as jobs from './jobs';
import * as parts from './parts';
import * as print from './print';
import * as speed_link from './speed_link';
import * as templates from './templates';

export default {
    api,
    checklists,
    colors,
    credentials,
    fields,
    jobs,
    parts,
    print,
    speed_link,
    templates,
};
